import 'intersection-observer';
import { useEffect, useState } from 'react';
import canUseDom from '../utils/canUseDom';

const useIntersection = (
  ref,
  {
    threshold = 0,
    rootMargin = canUseDom ? `${window.innerHeight / 2}px ${window.innerWidth / 2}px` : '0px',
    root,
    defaultInView,
  }
) => {
  const [inView, setInView] = useState(defaultInView);

  useEffect(() => {
    if (!inView && ref?.current) {
      let didCancel = false;

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (!didCancel) {
            if (entry.intersectionRatio > 0 || entry.isIntersecting) {
              setInView(true);
              observer.disconnect();
            }
          }
        },
        { threshold, root, rootMargin }
      );

      observer.observe(ref.current);

      return () => {
        didCancel = true;

        observer.disconnect();
      };
    }

    return undefined;
  }, [ref, inView]); // eslint-disable-line react-hooks/exhaustive-deps

  return inView;
};

export default useIntersection;
